import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";

export const getTableById = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables/${id}`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching tables:", err);
    throw err;
  }
};

export const getTables = async ({ status }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");
    const params = new URLSearchParams({});
    if (status) params.append("status", status);

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables/search?${params.toString()}`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching tables:", err);
    throw err;
  }
};

export const getAvailableTables = async ({ date }) => {
  try {
    const params = new URLSearchParams({});
    if (date) params.append("date", date);

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables/available?${params.toString()}`,
      method: "GET",
    });
    return res;
  } catch (err) {
    console.error("Error fetching tables:", err);
    throw err;
  }
};

export const createTable = async (body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables`,
      method: "POST",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching table:", err);
    throw err;
  }
};

export const updateTable = async (id, body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables/${id}`,
      method: "PUT",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching table:", err);
    throw err;
  }
};

export const deleteTable = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/tables/${id}`,
      method: "DELETE",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching table:", err);
    throw err;
  }
};
